var map = {
	"./email.png": 3005,
	"./etherscan.png": 9816,
	"./favicon.ico": 9986,
	"./opensea.png": 7235,
	"./spareSouls-1.png": 8956,
	"./spareSouls-2.png": 8466,
	"./spareSouls-3.png": 5855,
	"./spareSouls-4.png": 8503,
	"./twitter.png": 3220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;